export function buildResearchPaperPrompt(data) {
  const structureMap = {
    'IMRaD': 'Introduction → Methods → Results → Discussion (IMRaD format)',
    'Standard Academic': 'Introduction → Literature Review → Methodology → Analysis → Discussion → Conclusion',
    'Theory Paper': 'Introduction → Theoretical Framework → Conceptual Development → Propositions → Discussion → Conclusion',
  }

  const structure = structureMap[data.paperStructure] || structureMap['Standard Academic']
  const toneNote = data.targetJournal
    ? `Target: ${data.targetJournal}. Adjust tone accordingly — journal submissions require dense, formal argumentation; conference papers benefit from punchy, clear positioning.`
    : 'No specific target provided. Use formal journal article tone.'

  return `You are a senior academic researcher and editor with 40 years of experience publishing in peer-reviewed journals across management, social sciences, and policy. You have reviewed for leading journals and know exactly what editors look for.

Write a complete academic research paper based on the following brief.

PAPER DETAILS:
Title: ${data.title}
Core Argument / Thesis Statement: ${data.coreArgument}
Paper Structure: ${structure}
${toneNote}
Target Word Count: ${data.targetWords || 5000} words

${data.keyLiterature ? `KEY SOURCES AND LITERATURE TO ENGAGE:\n${data.keyLiterature}\n` : ''}

WRITING PROCEDURE:
Write the paper body sections first, in the order specified by the structure above.
After all body sections are complete, write the Abstract last — place it at the very beginning of the output (before the Introduction), but write it after having written the full paper.

SECTION-SPECIFIC REQUIREMENTS:

ABSTRACT (write last, place first):
- 150–250 words
- Cover: context, gap, method (briefly), key findings/argument, contribution
- No citations in abstract

INTRODUCTION:
- Open with the intellectual problem, not with "This paper examines..."
- Establish the gap clearly: what is missing, contested, or unresolved?
- End with an explicit statement of the paper's contribution — what specifically this paper adds

LITERATURE REVIEW / THEORETICAL FRAMEWORK:
- Must be analytical, not descriptive — what do scholars disagree about?
- Identify what this paper adds that prior work does not
- Citations are dense here — every major claim should be supported
- Organise thematically, not chronologically

METHODOLOGY (if applicable for IMRaD or Standard):
- Justify the approach philosophically and practically
- State limitations honestly

ANALYSIS / RESULTS / FINDINGS:
- Present findings clearly; do not interpret in results sections for IMRaD
- In Standard Academic, analysis and interpretation can be integrated

DISCUSSION:
- Connect findings back to the literature
- Address contradictions and unexpected results
- Moderate citation density

CONCLUSION:
- Synthesise only — no new material
- State theoretical and practical contributions
- Identify limitations and future research directions
- Minimal citations

HUMANIZER RULES — non-negotiable:
- Do NOT use: "delve", "testament", "pivotal", "groundbreaking", "landscape" (metaphor), "it is worth noting"
- Do NOT use "Furthermore", "Moreover", "Additionally" as sentence openers more than once per section
- Do NOT write in the pattern "X is important. Y is also important. Z plays a crucial role."
- Vary sentence length deliberately — short sentences after long ones create intellectual rhythm
- State positions directly — if evidence is thin, say so
- Cite selectively; cluster citations where the argument is genuinely fragile

PROFESSOR EFFECT:
- Name theoretical tensions; do not paper over disagreements
- Pick defensible positions and argue for them
- The paper should have a distinctive intellectual voice

APA 7th EDITION throughout. Use real, verifiable sources. Mark uncertain citations [verify DOI].

Begin with the Abstract, then write each section in order. No preamble.`
}
